export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"},{"name":"referrer","content":"origin-when-cross-origin"},{"name":"HandheldFriendly","content":"true"},{"name":"MobileOptimized","content":"width"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"format-detection","content":"telephone=no, address=no, email=no"},{"name":"color-scheme","content":"only light"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"}],"link":[{"rel":"preconnect","href":"https://ru.id.facct.ru"},{"rel":"preload","as":"font","type":"font/woff2","href":"/_static-files/fonts/GraphikLCG-Regular.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"/_static-files/fonts/GraphikLCG-Medium.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"video","type":"video/mp4","href":"/_static-files/splash.mp4","crossorigin":"anonymous"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"document.documentElement.style.setProperty(`--window-inner-height`, `${window.innerHeight}px`)"}],"noscript":[],"htmlAttrs":{"dir":"ltr","lang":"ru-RU"},"bodyAttrs":{"data-app":true,"data-resizing":false,"data-hover":"supported","data-adult-blur":false,"data-dir":"ltr","data-webview":"false","data-focus":"pointer"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 60000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true